import React, { FC, memo, useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import ErrorMessage from '@minecraft.error-message';
import { SEARCH_ROSTER_LISTS } from '../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = FilterData;

const RosterLists: FC<Props> = ({ name, label }) => {
  const [getRosterLists, { data, error, loading }] = useLazyQuery(SEARCH_ROSTER_LISTS);

  const handleListsFetch = useCallback((): void => {
    if (!data) {
      getRosterLists();
    }
  }, [data]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown
        saveAsOption
        name={name}
        isLoading={loading}
        onOptionsFetch={handleListsFetch}
      >
        {data?.getOrganizationProfileLists?.objects?.map((list) => (
          <FormikSelectableSearchDropdown.Option
            key={`roster-profile-${list.id}`}
            value={Number(list.id)}
            label={list.name}
          />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(RosterLists);
